<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width:100%;
  height:100%;
}

.fade2-enter{
  opacity: 0;
}
.fade2-leave{
  opacity: 1;
}
.fade2-enter-active{
  transition: opacity 0.2s;
}
.fade2-leave-active{
  transition: opacity 0.2s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue